import { baseApi } from "./baseApi";

export interface UsernameStatusResponse {
  usernameChanged: boolean;
}

// username change itself lives in authServiceApi (PUT /auth/username on auth)
export const authApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // check if username was already changed (backend tracks via oldUsernames)
    getUsernameStatus: builder.query<UsernameStatusResponse, void>({
      query: () => "/profile/username-status",
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetUsernameStatusQuery,
} = authApi;
